import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { DateDropdown } from '@dev/ee-components';
import React, { FC, useContext } from 'react';
import { useSelector } from 'react-redux';
import { parse } from 'query-string';

import dayjs from '@api/services/tools/dayjs';
import { getAccount } from '@api/store/account/types';

import { GlobalFilterOptionsContext } from '../../..';
import { DATE_FORMAT, DateFilterType } from '../../../LogsFiltersBarInterfaces';
import { ACTIVITY_TIME_RANGES, EXTENDED_LOGS_DAYS } from '@api/services/constants';
import { useDateDropdownOptions } from '@api/components/Logs/hooks/useDateDropdownOptions';
import { getDateDropdownValue } from '@api/services/tools/getDateDropdownValue';

export const DateFilter: FC<DateFilterType> = (): JSX.Element => {
    const {
        GeneralInfo: { AccountAccessLevel, KeepLogsForDays },
    } = useSelector(getAccount);
    const { onClicks, updateFilters } = useContext(GlobalFilterOptionsContext);

    const accountHasExtendedLogs = AccountAccessLevel.includes(AccessLevel.ExtendedLogs);
    const dateDropdownOptions = useDateDropdownOptions(accountHasExtendedLogs);

    const limitedLogsStoredDays = KeepLogsForDays;

    const query = parse(location.search);
    const startDate = query?.from?.toString();
    const endDate = query?.to?.toString();

    const minDate = dayjs()
        .startOf('day')
        .subtract(accountHasExtendedLogs ? EXTENDED_LOGS_DAYS : limitedLogsStoredDays, 'day')
        .utc()
        .toJSON() as any;

    const setDatesForLogs = (event: any, selectedItem: { label: string; value: string | number }): void => {
        const { value } = selectedItem;
        const to = dayjs().utc();
        const from = dayjs().subtract(+value, 'day').startOf('day').utc();

        const updatedFilters = {
            from: from.format(DATE_FORMAT),
            to: to.format(DATE_FORMAT),
        };

        updateFilters(updatedFilters);
        onClicks?.dateFilter(event, selectedItem);
    };

    const setDatesBasedOnCalendar = (fromTime: Date, toTime: Date): void => {
        const from = dayjs(fromTime).startOf('day').utc();
        const to = dayjs(toTime).utc();

        const updatedFilters = {
            from: from.format(DATE_FORMAT),
            to: to.format(DATE_FORMAT),
        };

        updateFilters(updatedFilters);
        onClicks?.calendar(fromTime, toTime);
    };

    return (
        <DateDropdown
            buttonVariant="tertiary"
            calendarOnChange={setDatesBasedOnCalendar}
            value={getDateDropdownValue(true, `${limitedLogsStoredDays}`, ACTIVITY_TIME_RANGES)}
            maxHeight={500}
            minWidth={75}
            options={dateDropdownOptions}
            type="input"
            returnRawData
            onItemClick={setDatesForLogs}
            placement="bottom-end"
            minDate={minDate}
            maxDate={dayjs().startOf('day').add(1, 'day').utc().toJSON()}
            startDate={startDate}
            endDate={endDate}
        />
    );
};
